import { render, staticRenderFns } from "./StepAddress.vue?vue&type=template&id=132d8ba3&"
import script from "./StepAddress.vue?vue&type=script&lang=js&"
export * from "./StepAddress.vue?vue&type=script&lang=js&"
import style0 from "./StepAddress.vue?vue&type=style&index=0&id=132d8ba3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports